import { deliveryDelayDays, deliveryMoneyValue } from './salesDeliveryForm';
import { deliveryParticipantEmailsValid } from './salesDeliveryRecipients';

const EMAIL_PATTERN = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

export const responsibleMode = paymentMethods => {
  const methods = (
    Array.isArray(paymentMethods) ? paymentMethods : [paymentMethods]
  ).map(String);
  if (methods.includes('1')) return 'seller';
  if (methods.includes('2')) return 'bank';
  if (methods.includes('4')) return 'internal';
  if (methods.includes('3')) return 'bank';
  return 'internal';
};

export const deliveryErrors = ({
  form,
  participants = [],
  t,
  today = new Date(),
}) => {
  const errors = {};
  const delay = deliveryDelayDays(form, today);

  if (!['manual', 'docusign'].includes(form.recibo_type)) {
    errors.recibo_type = t('SALES.DELIVERY.ERRORS.RECEIPT_TYPE');
  }
  if (form.recibo_type === 'manual' && !form.data_assinatura) {
    errors.data_assinatura = t('SALES.DELIVERY.ERRORS.REQUIRED');
  } else if (delay !== null && delay < 0) {
    errors.data_assinatura = t('SALES.DELIVERY.ERRORS.FUTURE_DATE');
  } else if (delay !== null && delay > 60) {
    errors.data_assinatura = t('SALES.DELIVERY.ERRORS.OLD_DATE');
  }
  if (delay !== null && delay >= 5 && delay <= 60 && !form.observacao) {
    errors.observacao = t('SALES.DELIVERY.ERRORS.DELAY_REASON');
  }
  if (!Number(form.prazo_escritura)) {
    errors.prazo_escritura = t('SALES.DELIVERY.ERRORS.REQUIRED');
  }
  if (!['1', '2'].includes(String(form.prazo_type))) {
    errors.prazo_type = t('SALES.DELIVERY.ERRORS.DEADLINE_TYPE');
  }
  if (form.recibo_type === 'docusign') {
    if (form.email_check !== '1') {
      errors.email_check = t('SALES.DELIVERY.ERRORS.CONFIRM_EMAILS');
    } else if (!deliveryParticipantEmailsValid(participants)) {
      errors.email_check = t('SALES.DELIVERY.ERRORS.MISSING_EMAILS');
    }
  }
  if (form.recibo_type === 'docusign') {
    (form.testemunhas || []).forEach((witness, index) => {
      if (!witness.name) {
        errors[`witness_${index}_name`] = t('SALES.DELIVERY.ERRORS.REQUIRED');
      }
      if (!EMAIL_PATTERN.test(witness.email || '')) {
        errors[`witness_${index}_email`] = t(
          'SALES.DELIVERY.ERRORS.INVALID_EMAIL'
        );
      }
    });
  }
  if (!form.valor_comissao_total) {
    errors.valor_comissao_total = t('SALES.DELIVERY.ERRORS.REQUIRED');
  } else {
    const total = deliveryMoneyValue(form.valor_comissao_total);
    const deduction = deliveryMoneyValue(form.deducao);
    if (total === null || deduction === null) {
      errors.valor_comissao_total = t('SALES.DELIVERY.ERRORS.INVALID_MONEY');
    } else if (total <= deduction) {
      errors.deducao = t('SALES.DELIVERY.ERRORS.DEDUCTION');
    }
  }
  if (form.reforco === '16' && !form.reforco_observacao) {
    errors.reforco_observacao = t('SALES.DELIVERY.ERRORS.REINFORCEMENT');
  }
  if (
    ['seller', 'bank'].includes(responsibleMode(form.forma_pagamento)) &&
    (!form.id_responsavel_chaves || form.id_responsavel_chaves === '0')
  ) {
    errors.id_responsavel_chaves = t('SALES.DELIVERY.ERRORS.REQUIRED');
  }
  return errors;
};
